import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Tooltip from '@mui/material/Tooltip';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';

import FormGroup from '@mui/material/FormGroup';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import AdminMenuComponent from "../../../components/admin/AdminMenuComponent.js";

import CreateEventElementCard from "./CreateEventElementCard.js";

const config = require("../../../constants/constants.js")

const CreateEventPageComponent = ({
  createEventApiRequest,
  uploadImagesApiRequest,
  uploadImagesCloudinaryApiRequest,
  categories,
  reduxDispatch,
  newCategory,
  deleteCategory,
  saveAttributeToCatDoc
}) => {

  const navigate = useNavigate();

  const [validated, setValidated] = useState(false);
  const [event, setEvent] = useState({});

  const [updateEventResponseState, setUpdateEventResponseState] = useState({
    message: "",
    error: "",
  });

  const [attributesTable, setAttributesTable] = useState([]);
  const [attributesFromDb, setAttributesFromDb] = useState([]);
  const [isCreating, setIsCreating] = useState("");
  const [createEventResponseState, setCreateEventResponseState] = useState({
    message: "",
    error: "",
  });
  const [categoryChoosen, setCategoryChoosen] = useState("Choose category");
  
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [note, setNote] = useState("");
  const [color, setColor] = useState("");
  const [count, setCount] = useState(0);
  const [price, setPrice] = useState(0);
  const [isBookable, setIsBookable] = useState(false);
  const [bookingPrice, setBookingPrice] = useState(0);
  const [category, setCategory] = useState("");
  const [images, setImages] = useState([]);
  const [pdfs, setPdfs] = useState([]);
  const [linkHttp, setLinkHttp] = useState("");

  const [displayPaperImages, setDisplayPaperImages] = useState("");

  const [page, setPage] = useState({});
  const [imageRemoved, setImageRemoved] = useState(false)
  const [isUploading, setIsUploading] = useState("");
  const [imageUploaded, setImageUploaded] = useState(false);
  const [id, setId] = useState("");
  const [idStoreImages, setIdStoreImages] = useState("");
  const [pageImageItems, setPageImageItems] = useState([]);

  const url_image_elenco = config.URL_IMAGES_CUSTOMER1;

  const [eventsList, setEventsList] = useState([]);

  function handleSalva(event) {

    event.preventDefault();
    event.stopPropagation();

    const formInputs = {
      name: name,
      description: description,
      note: note,
      count: count,
      color: color,
      price: price,
      isBookable: isBookable,
      bookingPrice: bookingPrice,
      category: category,
      images: images,
      pdfs: pdfs,
      linkHttp: linkHttp,
      attributesTable: attributesTable,
    };

    console.log('[handleSalva] formInputs=', formInputs)

    /*
    if (images.length > 10) {
      setIsCreating("to many files [max 10]");
      return;
    }
    */
    createEventApiRequest(formInputs)
      .then((data) => {
        if (images) {
          console.log('[handleSalva] data=', data)
          console.log('[handleSalva] id =', data?.eventId)
          setId(data?.eventId);
          setIdStoreImages(data?.eventId);
          console.log('[handleSalva] idStoreImages =', idStoreImages)
          window.location.assign(`/admin/edit-event/${data?.eventId}`)
        }
      })
      .catch((er) => {
        setCreateEventResponseState({
          error: er.response.data.message
            ? er.response.data.message
            : er.response.data,
        });
      });
    //setDisplayPaperImages("block");
    //window.location.assign('/admin/events')
  };

  const handleLoadImage = (event) => {
    const files = Array.from(event.target.files);
    const statusStep = 100 / files.length;

    console.log("[handleLoadImage] event.target.files=" + event.target.files)
    console.log("[handleLoadImage] files.length=" + files.length)

    for (let i = 0; i < files.length; i++) {
      // ## controllo dimensione totale
      //
      // uploadItem(files[i]);
      // Here it guarantees that state updated correctly
      // setState(prevStep => prevStep + statusStep);
    }

    setIsUploading("upload files in corso ...");
    uploadEventImagesApiRequest(event.target.files, id)
      .then(data => {
        //if (data.message === "event updated") navigate("/admin/events");
        setIsUploading("upload files completato");
        setImageUploaded(!imageUploaded);
      })
      .catch((er) => setIsUploading(er.response.data.message ? er.response.data.message : er.response.data));
    window.location.assign(`/admin/edit-event/${id}`)
  };

  const uploadEventImagesApiRequest = async (images, eventId) => {

    console.log("[uploadEventImagesApiRequest]")
    console.log("[uploadEventImagesApiRequest] images=", images)
    console.log("[uploadEventImagesApiRequest] id=", eventId)

    const formData = new FormData();
    Array.from(images).forEach((image) => {
      formData.append("images", image);
    });

    console.log("[uploadEventImagesApiRequest] formData=", formData)
    console.log("[uploadEventImagesApiRequest] POST /api/events/admin/upload?eventId")

    const { data } = await axios.post("/api/events/admin/upload?eventId=" + eventId, formData);
    return data;
  };

  function gotoIndietro(eventKey) {
    eventKey.preventDefault();
    eventKey.stopPropagation();

    window.location.assign('/admin/events')
  }

  const switchIsBookableHandler = (event) => {
    setIsBookable(event.target.checked);
    console.log('[switch] isBookable =', isBookable)
  };

  const handleSelectEvent = (event) => {
    setCategory(event.target.value);
  };

  useEffect(() => {
    setDisplayPaperImages("none")
  }, [setDisplayPaperImages]);

  const getCategories = async (abctrl) => {
      const {data} = await axios.get("/api/eventtypes", {
          signal: abctrl.signal,
      });
      return data
  }

  useEffect(() => {
    const abctrl = new AbortController();
    getCategories(abctrl)
      .then((res) => setEventsList(res))
      .catch((er) =>
        console.log("error")
      );
    return () => abctrl.abort();
  }, [setEventsList]);

  return (

    <Box sx={{ flexGrow: 1 }}>

      <Grid container spacing={2}>

        <AdminMenuComponent></AdminMenuComponent>

        <Box
          paddingLeft={{ xs: 3, md: 3 }}
          paddingRight={{ xs: 3, md: 3 }}
        >

          <Breadcrumbs separator="›" aria-label="breadcrumb"
            size={{ xs: 12, md: 4 }}
            paddingTop={{ xs: 0, md: 0 }}
            paddingLeft={{ xs: 0, md: 0 }}
            paddingRight={{ xs: 1, md: 8 }}
            spacing={{ xs: 2, md: 2 }}
          >
            <Link underline="hover" color="inherit" href="/admin/welcome">
              {config.BC_ADMIN}
            </Link>
            <Link underline="hover" color="inherit" href="/admin/events">
              {config.BC_ADMIN_EVENTS}1
            </Link>
            <Typography sx={{ color: 'text.primary' }}>{config.BC_ADMIN_EVENTS_CREATE}</Typography>
          </Breadcrumbs>

          <Stack
            sx={{
              flexDirection: { xs: "row", md: "row" },
              paddingTop: 2, paddingLeft: 0, paddingRight: 0,
            }}
          >
            <Typography
              sx={{ paddingTop: 0, paddingLeft: 0, paddingRight: 0, }}
              variant="h4"
            >
              <b>Crea evento</b>&nbsp;
            </Typography>
          </Stack>

          <Grid
            useFlexGap
            sx={{
              flexDirection: { xs: "column", md: "row" },
              paddingTop: 2, paddingLeft: 0, paddingRight: 0,
              flexWrap: 'wrap'
            }}
          >

            <Box
              sx={{ flexDirection: { xs: "column", md: "column" } }}
            >

              <Box
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  height: 30
                }}
              />

              <Paper
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  background: '#cce0e6'
                }}
                elevation={6}
              >

                <Stack
                  useFlexGap
                  sx={{
                    flexDirection: { xs: "column", md: "row" },
                    paddingTop: 2, paddingLeft: 0, paddingRight: 0,
                    flexWrap: 'wrap'
                  }}
                >

                  <TextField id="id-name" label="Nome" variant="outlined"
                    sx={{
                      width: "45ch",
                      p: { xs: 1, md: 1 },
                      m: { xs: 1, md: 1 },
                    }}
                    onChange={(event) => {
                      setName(event.target.value);
                    }}
                  />

                  <TextField id="id-description" label="Descrizione" variant="outlined"
                    sx={{
                      width: "55ch",
                      p: { xs: 1, md: 1 },
                      m: { xs: 1, md: 1 },
                    }}
                    onChange={(event) => {
                      setDescription(event.target.value);
                    }}
                  />

                  <TextField id="id-note" label="Note" variant="outlined"
                    sx={{
                      width: "65ch",
                      p: { xs: 1, md: 1 },
                      m: { xs: 1, md: 1 },
                    }}
                    onChange={(event) => {
                      setNote(event.target.value);
                    }}
                    multiline
                    rows={3}
                    maxRows={6}
                  />

                  <TextField id="id-color" label="Colore" variant="outlined" type="color"
                    sx={{
                      width: "20ch",
                      p: { xs: 1, md: 1 },
                      m: { xs: 1, md: 1 },
                    }}
                    onChange={(event) => {
                      setColor(event.target.value);
                    }}
                  />

                  <TextField id="id-count" label="Quantità" variant="outlined" type="number"
                    sx={{
                      width: "15ch",
                      p: { xs: 1, md: 1 },
                      m: { xs: 1, md: 1 },
                    }}
                    onChange={(event) => {
                      setCount(event.target.value);
                    }}
                  />

                  <FormControl
                    sx={{
                      width: "20ch",
                      p: { xs: 1, md: 1 },
                      m: { xs: 1, md: 1 },
                    }}
                    onChange={(event) => {
                      setPrice(event.target.value);
                    }}
                  >
                    <InputLabel htmlFor="outlined-adornment-amount">Prezzo</InputLabel>
                    <OutlinedInput
                      id="outlined-adornment-amount"
                      startAdornment={<InputAdornment position="start">€</InputAdornment>}
                      label="Prezzo"
                      type="number"
                    />
                  </FormControl>

                  <FormControl
                    sx={{
                      width: "40ch",
                      p: { xs: 1, md: 1 },
                      m: { xs: 1, md: 1 },
                    }}
                  >
                    <InputLabel id="style-select-label">
                      tipo evento
                    </InputLabel >
                    <Select
                      labelId="style-select-label"
                      id="style-select-label"
                      value={category}
                      label="tipo evento"
                      onChange={handleSelectEvent}
                    >

                      {eventsList.map((categoryItem, idx) => (
                        <MenuItem value={categoryItem.name}>{categoryItem.name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <TextField id="id-linkHttp" label="link http" variant="outlined"
                    sx={{
                      width: "55ch",
                      p: { xs: 1, md: 1 },
                      m: { xs: 1, md: 1 },
                    }}
                    onChange={(event) => {
                      setLinkHttp(event.target.value);
                    }}
                  />

                </Stack>

                <Stack
                  sx={{
                    flexDirection: { xs: "row", md: "row" },
                    paddingTop: 2, paddingLeft: 2, paddingRight: 0,
                  }}
                >

                  <FormControlLabel
                    control={<Switch defaultChecked />}
                    checked={isBookable}
                    onChange={switchIsBookableHandler}
                    label="Prenotabile"
                    sx={{
                      paddingTop: 0, paddingLeft: 4, paddingRight: 0,
                    }}
                  />

                  {isBookable &&

                    <Stack
                      sx={{
                        flexDirection: { xs: "row", md: "row" },
                        paddingTop: 2, paddingLeft: 0, paddingRight: 0,
                      }}
                    >

                      <FormControl
                        sx={{ m: 0, paddingTop: 0, paddingLeft: 0, paddingRight: 0, }}
                        style={{
                          width: "20ch",
                        }}
                        onChange={(event) => {
                          setBookingPrice(event.target.value);
                        }}
                      >
                        <InputLabel htmlFor="outlined-adornment-amount">Importo prenotazione</InputLabel>
                        <OutlinedInput
                          id="outlined-adornment-amount"
                          startAdornment={<InputAdornment position="start">€</InputAdornment>}
                          label="Importo prenotazione"
                          type="number"
                          defaultValue={bookingPrice}
                          value={bookingPrice}
                        />
                      </FormControl>

                    </Stack>
                  }

                </Stack>

                <Stack
                  sx={{
                    paddingTop: 1, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                    display: 'flex',
                    flexDirection: { xs: "row", md: "row" },
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >

                  <Button
                    type="button"
                    variant="contained"
                    color="warning"
                    onClick={(e) => { gotoIndietro(e); }}
                    sx={{
                      width: "12ch",
                      p: 1,
                      m: 1,
                    }}
                  >
                    Indietro
                  </Button>

                  <Button
                    variant="contained"
                    type="submit"
                    color="success"
                    onClick={handleSalva}
                    sx={{
                      width: "12ch",
                      p: 1,
                      m: 1,
                    }}
                  >
                    Salva
                  </Button>
                </Stack>

                <Box
                  sx={{
                    paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                    height: 20
                  }}
                />

              </Paper>

              <Box
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  height: 30
                }}
              />

              <Paper
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  background: '#cce0e6',
                  //display: "none"
                  //display: "block"               
                  display: displayPaperImages
                }}
              >

                <Box
                  sx={{
                    paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  }}
                >

                  <Stack
                    sx={{
                      paddingTop: 1, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                      display: 'flex',
                      flexDirection: { xs: "row", md: "row" },
                      alignItems: "center",
                      justifyContent: "center"
                    }}
                  >

                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      size="small"
                      component="label"
                      fullWidth
                      sx={{
                        width: "20ch",
                        p: 1,
                        m: 1,
                      }}
                    >
                      Carica immagine
                      <input type="file" onChange={handleLoadImage} hidden multiple />
                    </Button>

                    <Typography variant="h6" color="navy"
                      sx={{
                        width: "20ch",
                        p: 1,
                        m: 1,
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 10, paddingRight: 0,
                      }}
                    >
                      {pageImageItems.length} immagini caricate
                    </Typography>

                    <Typography variant="h9" color="black"
                      sx={{
                        width: "50ch",
                        p: 1,
                        m: 1,
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 10, paddingRight: 0,
                      }}
                    >
                      puoi modificare titoli e info
                    </Typography>

                  </Stack>

                  <Stack
                    sx={{
                      flexDirection: { xs: "row", md: "row" },
                      paddingTop: 0, paddingLeft: 0, paddingRight: 0, paddingBottom: 1,
                      position: "center", overflowX: "scroll",
                      '@media (min-width: 600px)': { width: '1400px' },
                      '!@media (min-width: 600px)': { width: '500px' },
                    }}
                  >

                    {images.map((image, idx) => (

                      <CreateEventElementCard key={idx} imagePath={image.path} idx={idx} pageId={id} nameImage={image.name} titleImage={image.title} subTitleImage={image.subTitle} pageAll={event} />

                    ))}

                  </Stack>

                </Box>

              </Paper>

              <Box
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  height: 30
                }}
              />

            </Box>

          </Grid>

        </Box>

      </Grid>

    </Box>

  );
};

export default CreateEventPageComponent;
